import { render, staticRenderFns } from "./SmallSectionTitle.vue?vue&type=template&id=97acaab2&"
import script from "./SmallSectionTitle.vue?vue&type=script&lang=js&"
export * from "./SmallSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SmallSectionTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports